"use client";

import Box from "@mui/material/Box";
import { SxProps } from "@mui/material";
import { ReactNode } from "react";
import { trackContactClick } from "@v2/lib/analytics";

/**
 * A phone or WhatsApp link that reports itself.
 *
 * It exists because the places these links live are server components, and a
 * server component cannot carry a click handler. Everything else about the
 * anchor stays where it was.
 */
export default function ContactLink({ channel, location, href, sx, ariaLabel, target, className, children }: {
    channel: "whatsapp" | "phone";
    location: string;
    href: string;
    sx?: SxProps;
    ariaLabel?: string;
    target?: string;
    className?: string;
    children: ReactNode;
}) {
    return (
        <Box
            component="a"
            href={href}
            target={target}
            className={className}
            aria-label={ariaLabel}
            onClick={() => trackContactClick(channel, location)}
            sx={sx}
        >
            {children}
        </Box>
    );
}
